import React, { useEffect, useState } from "react";
import { Routes as Switch, Route, useLocation } from "react-router-dom";

import { useRecoilState, useSetRecoilState } from "recoil";
import { userInfo, userCredentials, miaServices, userCoords } from "./recoilState/GlobalState";

import { getUserCredentials } from "services/getUserCredentials";
import { checkAuth } from "services/checkAuth";
import { usuarioMinimosGet } from "services/services-mia";

import ProtectedRoute from "./components/route/ProtectedRoute";
import { CircularIndeterminate, Header } from "components";
import SnackBar from "components/utils/snackbars/Snackbar";

import {
    Dashboard,
    Accesos,
    Horarios,
    Kioscos,
    Eventos,
    Login,
    UsuariosXServicio,
    DocumentType,
    Documents,
    PdfAnnotationPublisher,
    UsuariosMIAKey,
    Zonas,
    UserDetailsDashboard,
    TipoDePaso,
    Paso,
    UsuariosPaso,
    Hoteles,
    Vouchers,
    Monitor,
    MonitorPasos,
    Vuelos,
} from "./pages";

import { Routes as ROUTES } from "./consts/Routes-App";
import { DEFAULT_COORDS, GEOLOCATION_TIMEOUT_MS } from "./consts/DefaultCoords";
import { log } from "./utils/logger";

import ServiceRoute from "components/route/ServiceRoute";
import { merchantLogoGet } from "services/services-mia/merchant";
import { loginServicioGet } from "services/services-mia/login";

import s from "./App.module.scss"

export default function App() {
    const [loading, setLoading] = useState(true);
    const [isAuth, setIsAuth] = useState(false);

    const [credentials, setCredentials] = useRecoilState(userCredentials);
    const setInfo = useSetRecoilState(userInfo);
    const setServices = useSetRecoilState(miaServices);
    const setCoords = useSetRecoilState(userCoords);

    const location = useLocation();

    useEffect(() => {
    if (!navigator.geolocation) {
      log.warn("Geolocalización no disponible, se usan coordenadas por defecto");
      setCoords(DEFAULT_COORDS);
      return;
    }

        navigator.geolocation.getCurrentPosition(
            (data) => {
                setCoords({
                    lat: data.coords.latitude,
                    lng: data.coords.longitude,
                });
            },
            (error) => {
        // Permiso denegado / posición no disponible / timeout: sin coords el
        // login no puede pedir el QR, así que se cae al default.
        log.warn("Error de localización, se usan coordenadas por defecto", error?.code);
        setCoords(DEFAULT_COORDS);
      },
      { timeout: GEOLOCATION_TIMEOUT_MS }
        );
    }, [setCoords]);

    useEffect(() => {
        setLoading(true);
        (async () => {
            const newCredentials = await getUserCredentials();
            if (newCredentials) {
                setCredentials(newCredentials);
                const userData = await usuarioMinimosGet(newCredentials);
                const { result: merchantData } = await merchantLogoGet({}, newCredentials);
                setInfo({ ...merchantData[0], ...userData });
                const { result: servicesData } = await loginServicioGet({}, newCredentials);
                setServices(servicesData);
            }
            setIsAuth(checkAuth());
            setLoading(false);
        })();
    }, [setCredentials, setInfo, setServices]);

    useEffect(() => {
        if (loading) return;
        setIsAuth(checkAuth());
    }, [credentials, loading]);

    if (loading) return <CircularIndeterminate />;

    return (
        <div className={s.container}>
            <div className={setIsAuth.header}>
                {location.pathname !== ROUTES.login.route && <Header />}

            </div>
            <div className={s.body}>
                <SnackBar />

                <Switch>
                    <Route path={ROUTES.login.route} exact element={<Login />} />

                    <Route
                        element={
                            <ProtectedRoute
                                redirectProtectedRoute={ROUTES.login.route}
                                isAuth={isAuth}
                            />
                        }
                    >
                        <Route
                            path={ROUTES.dashboard.route}
                            exact
                            element={<Dashboard route={ROUTES.dashboard} />}
                        />
                        <Route
                            path={"usuarios/:usuarioId/details"}
                            element={<UserDetailsDashboard />}
                        />
                        <Route
                            path="servicio/IDBASE"
                            element={<ServiceRoute servicioCod="IDBASE" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route
                                path="usuarios"
                                element={<UsuariosXServicio />}
                            />
                        </Route>
                        <Route
                            path="servicio/LBM"
                            element={<ServiceRoute servicioCod="LBM" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route
                                path="usuarios"
                                element={<UsuariosXServicio />}
                            />
                        </Route>
                        <Route
                            path="servicio/SIGN"
                            element={<ServiceRoute servicioCod="SIGN" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route
                                path="usuarios"
                                element={<UsuariosXServicio />}
                            />
                            <Route path="config">
                                <Route
                                    path="tipo_documento"
                                    exact
                                    element={<DocumentType />}
                                />
                            </Route>
                            <Route path="admin">
                                <Route
                                    path="documents"
                                    exact
                                    element={<Documents />}
                                />
                                {/* <Route
                                    path="pdf_annotation"
                                    exact
                                    element={<PdfAnnotationEditor />}
                                /> */}
                                <Route
                                    path="publicar"
                                    exact
                                    element={<PdfAnnotationPublisher />}
                                />
                            </Route>
                        </Route>
                        <Route
                            path="servicio/RMIGRA"
                            element={<ServiceRoute servicioCod="RMIGRA" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route
                                path="usuarios"
                                element={<UsuariosXServicio />}
                            />
                            <Route path="admin">
                                <Route
                                    path="usuarios_pasos"
                                    element={<UsuariosPaso />}
                                />
                                <Route
                                    path="monitor"
                                    element={<MonitorPasos />}
                                />
                                <Route
                                    path="vuelos"
                                    element={<Vuelos />}
                                />
                            </Route>
                            <Route path="config">
                                <Route
                                    path="tipos_paso"
                                    element={<TipoDePaso />}
                                />
                                <Route path="pasos" element={<Paso />} />
                            </Route>
                        </Route>
                        <Route
                            path="servicio/HGATE"
                            element={<ServiceRoute servicioCod="HGATE" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route
                                path="usuarios"
                                element={<UsuariosXServicio />}
                            />
                            <Route path="config">
                                <Route
                                    path="zonas"
                                    element={<Zonas />}
                                />
                                <Route
                                    path="accesos"
                                    element={<Accesos />}
                                />
                                <Route
                                    path="kioscos"
                                    element={<Kioscos />}
                                />
                                <Route
                                    path="horarios"
                                    element={<Horarios />}
                                />
                            </Route>
                            <Route path="admin">
                                <Route
                                    path="eventos"
                                    element={<Eventos />}
                                />
                                <Route
                                    path="usuarios"
                                    element={<UsuariosMIAKey />}
                                />
                                <Route
                                    path="monitor"
                                    element={<Monitor />}
                                />
                            </Route>
                        </Route>
                        <Route
                            path="servicio/SFHOTEL"
                            element={<ServiceRoute servicioCod="SFHOTEL" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route
                                path="usuarios"
                                element={<UsuariosXServicio />}
                            />
                            <Route path="config">
                                <Route
                                    path="hoteles"
                                    element={<Hoteles />}
                                />
                                <Route
                                    path="vouchers"
                                    element={<Vouchers />}
                                />
                            </Route>
                        </Route>
                        {/* Ruta temporal para maquetado de páginas*/}
                        {/* <Route path="dev/vouchers" element={<Vouchers />} /> */}
                        {/* <Route
                            path="/*"
                            element={<Vouchers />}
                        /> */}
                    </Route>
                </Switch>
            </div>
        </div>
    );
}
